import { useEffect, useRef, useState } from "react";

// Desktop-only trailing neon ring cursor that grows over interactive elements.
export const CustomCursor = () => {
  const ringRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    setEnabled(true);

    const ring = ringRef.current;
    if (!ring) return;
    let rx = window.innerWidth / 2;
    let ry = window.innerHeight / 2;
    let x = rx;
    let y = ry;
    let raf;

    const move = (e) => { x = e.clientX; y = e.clientY; };
    const over = (e) => {
      const hit = e.target.closest("a,button,[role=button],input,textarea,select,.cursor-pointer");
      ring.classList.toggle("rc-cursor--active", !!hit);
    };
    const loop = () => {
      rx += (x - rx) * 0.2;
      ry += (y - ry) * 0.2;
      ring.style.transform = `translate(${rx}px, ${ry}px)`;
      raf = requestAnimationFrame(loop);
    };

    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      cancelAnimationFrame(raf);
    };
  }, []);

  if (!enabled) return null;
  return <div ref={ringRef} className="rc-cursor" data-testid="custom-cursor" aria-hidden="true" />;
};
